import React from "react"
import { ConsentProvider } from "./src/context/ConsentContext"

export const wrapRootElement = ({ element }) => (
  <ConsentProvider>{element}</ConsentProvider>
)
